export enum PaymentCollector {
  AIRBNB = 'airbnb',
  BOOKING = 'booking',
  PAYMOB = 'paymob',
  GEIDEA = 'geidea',
  BIRDNEST = 'birdnest',
  EXPEDIA = 'expedia'
}
